import {
  Asterisk,
  ClockRotateRight,
  Eye,
  Language,
  Linear
} from 'iconoir-react';

const triggerCategoryIconMapping = {
  'Web Protocols': Language,
  none: Linear,
  'Messaging and Events': Eye,
  Others: Asterisk,
  Scheduling: ClockRotateRight
};

export type TriggerCategory = keyof typeof triggerCategoryIconMapping;

export const getTriggerCategoryIcon = (category?: TriggerCategory) => {
  if (category && category in triggerCategoryIconMapping) {
    return triggerCategoryIconMapping[category];
  }
  return triggerCategoryIconMapping.none;
};
